/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { sizes, Spacer, colors } from '@smartsheet/lodestar-core';
import React from 'react';
import { getVerticalSpacingAroundRunSteps } from '../../../../../../utils/dimensions';

const shine = `
  @keyframes shine: {
    0%: {
      background-position: -100px;
    },
    40%, 100%: {
      background-position: 140px;
    }
  }
`;

const shineColour = 'rgba(229,229,229,0.8)';
const backgroundGradient = {
  backgroundImage: `linear-gradient(90deg, ${colors.neutralLight20} 0px, ${shineColour} 40px, ${colors.neutralLight20} 80px)`,
  backgroundSize: '600px',
};

const animationDuration = '2.0s';

// TODO: If this is being used for the third time(used here and run log list), time to consider making this as reusable as possible
const baseStyle = `
    height: 12px;
    border-radius: ${sizes.xSmall}px;
    background-color: ${colors.neutralLight40};
    background-image: ${backgroundGradient.backgroundImage};
    background-size: ${backgroundGradient.backgroundSize};
    animation: ${shine} ${animationDuration} infinite ease-out;
    box-sizing: border-box;
`;
const wrapper = css`
  display: flex;
  height: 28px;
  align-items: center;
`;

const childWrapper = css`
  ${wrapper};
  margin-left: 30px;
`;
const arrowIcon = css`
  ${baseStyle};
  width: 16px;
`;
const stepName = css`
  ${baseStyle};
  margin-left: 8.5px;
  flex-grow: 3;
`;

const typeIcon = css`
  ${arrowIcon};
  margin-left: 8.5px;
`;

const getChildObjects = (count: number) => {
  const placeholders = [];
  for (let i = 0; i < count; i++) {
    placeholders.push(
      <Spacer orientation="row" space="small" key={i} css={childWrapper}>
        <div css={arrowIcon} />
        <div css={stepName} />
      </Spacer>
    );
  }
  return placeholders;
};

export const LoadingState = () => {
  const placeholders = [];
  for (let i = 0; i < 5; i++) {
    placeholders.push(
      <React.Fragment>
        <Spacer orientation="row" space="small" key={i} css={wrapper}>
          <div css={arrowIcon} />
          <div css={typeIcon} />
          <div css={stepName} />
        </Spacer>
        {getChildObjects(4)}
      </React.Fragment>
    );
  }

  return (
    <div
      css={css`
        margin-top: ${sizes.medium}px;
        height: calc(100vh - ${getVerticalSpacingAroundRunSteps()}px);
      `}
    >
      {placeholders}
    </div>
  );
};
